/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import InputForm from '@/components/atoms/input/InputForm'
import * as yup from "yup";
import { handleChangeField, handleChangeSelect } from '@/utility/helper/dataMutation';
import InputSearch from '@/components/atoms/input/inputSearch';
import { StyledButton, BlogPagination } from '@/components';
import { CardLatestNews, GeneralEmptyData, MetaData, PageLoading } from '@/components/atoms';
import useBlogQuery from '@/utility/hooks/apiHooks/useBlog';
import route_list from '@/constant/routeUrl';
import { getLanguage } from '@/utility/helper/generalHandler';
import Head from 'next/head';
import DataHandlerContext from '@/utility/context/dataHandler';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { getSeoMetadata } from '@/utility/apiProcess/seo/server';

// import heroSection from './heroSection'
import ServicesSection from './serviceSection';
import TeamSection from './teamSection';
import TestimonialsSection from './testimonialsSection';

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'enterprise'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
      props: {
    seoMetadata: seoMetadata.data.result || {},
          ...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
      },
  }
}

const Enterprise = (props) => {
    const {language, token, role, dataUser, dispatch}:any = useContext(DataHandlerContext)
    const { t } = useTranslation('blog')
    const router = useRouter()
    const [timer, setTimer] = useState<NodeJS.Timeout | number>(0)
    const {blogList, startBlogList, blogPageInfo, featuredBlog, startFeatureBlogList, loadingBlogList, loadingFeaturedBlogList } = useBlogQuery()
    const [currentLang, setCurrentLang] = useState(language)
    const lang = language

    const handleOnChange = (event:any, targetMutation:any, setTargetMutation:any) => {
    let clone_filter = _.cloneDeep(formToState)
    const targetType = event.target.type
    if(targetType === 'search') {
      clone_filter = handleChangeField(event, targetMutation)
    }
    setTargetMutation(clone_filter)

    clearTimeout(timer)
    const new_time = setTimeout(() => {
    //   handleFilter(clone_filter, 'filter_data')
    }, 2000)

    setTimer(new_time)
  }

    // const handleFilter = (params:any = null, type:string) => {
    // let filter_data:any = {}

    // if(type === 'filter_data') {
    //   params.forEach((item:any) => {
    //     if(item.value) {
    //       if(_.isObject(item.value) && !_.isDate(item.value)) {
    //         filter_data[item.name] = item.value.value
    //       } else if(_.isDate(item.value)) {
    //         filter_data[item.name] = dayjs(item.value).format('YYYY-MM-DD')
    //       } else {
    //         filter_data[item.name] = item.value
    //       }
    //     }
    //   })

    //   filter_data = _.merge(filter_data)
    // } else if(type === 'pagination') {
    //   _.cloneDeep(filterSearch).forEach((item:any) => {
    //     if(item.value) {
    //       filter_data[item.name] = item.value
    //     }
    //   })
    //   filter_data = _.merge(filter_data, params)
    // } else {
    //   let clone_filter = _.cloneDeep(filterSearch)
    //   clone_filter = clone_filter.map((item:any) => {
    //     return {
    //       ...item,
    //       value: ''
    //     }
    //   })
    //   setFilterSearch(clone_filter)
    // }

    // console.log(filter_data)
    // startBlogList({page:1, limit: 10, order: 'desc', ...filter_data})
//   }

    useEffect(() => {
    if(!_.isEmpty(language)) {
            // startBlogList({page:1, limit: 10, order: 'desc'})
            // startFeatureBlogList()
    }
  }, [language])

    if(loadingFeaturedBlogList || loadingBlogList) {
        return <PageLoading />
    }

    return (
        <>
        <MetaData title={`Enterprise - ` +props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={`Enterprise - ` +props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />   
        

         <section className="sm:tw-pt-24 tw-pb-16 md:tw-pt-[200px] md:tw-pb-[200px] tw-relative tw-overflow-hidden">
            <div className="tw-absolute tw-inset-0 tw-h-[410px] sm:tw-h-screen tw-bg-gradient-to-r tw-from-dark_green1 tw-to-dark_green2 tw-opacity-[0.6]" />
            <div
                className="sm:tw-absolute tw-inset-0 tw-t-0 tw-h-[410px] sm:tw-h-screen tw-bg-cover tw-bg-center tw-mix-blend-overlay"
                style={{
                    backgroundImage: "url('https://i.ibb.co.com/PG6Xbtqr/hero-n1.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center"
                }}
            />
            <div className="tw-container tw-mx-auto tw-px-5 sm:tw-px-6 lg:tw-px-8 tw-relative">
                <div className="tw-flex tw-flex-col md:tw-flex-row tw-items-center">
                <div className="tw-w-full md:tw-w-1/2 lg:tw-w-5/12 tw-bg-[rgba(255,255,255,0.7)] sm:tw-shadow-xl tw-py-7 sm:tw-py-8 sm:tw-p-8 md:tw-p-12 tw-rounded-lg">
                    <h4 className="tw-text-primary tw-font-medium tw-text-sm md:tw-text-base tw-mb-2">
                    Tingkatkan Visibilitas Brand Anda
                    </h4>
                    <h1 className="tw-text-2xl md:tw-text-4xl tw-font-bold tw-text-dark tw-mb-4">
                    Solusi terbaik untuk branding perusahaan anda
                    </h1>
                    <p className="tw-text-gray-600 tw-mb-8 tw-text-sm">
                    Kami membantu perusahaan Anda membangun identitas brand yang kuat dan meningkatkan engagement di media sosial untuk pertumbuhan bisnis yang berkelanjutan.
                    </p>
                    <div className="tw-flex tw-flex-col sm:tw-flex-row tw-space-y-4 sm:tw-space-y-0 sm:tw-space-x-4">
                    <a
                        href=""
                        className="tw-px-6 tw-py-3 tw-bg-primary tw-text-white tw-font-medium tw-rounded-md tw-text-center hover:tw-bg-indigo-700 tw-transition tw-duration-300"
                    >
                        Konsultasi Gratis
                    </a>
                    <a
                        href="#services"
                        className="tw-px-6 tw-py-3 tw-border tw-border-primary tw-text-primary tw-font-medium tw-rounded-md tw-text-center hover:tw-bg-gray-50 tw-transition tw-duration-300 tw-flex tw-items-center tw-justify-center"
                    >
                        Layanan Kami
                        <svg
                        xmlns=""
                        className="tw-h-5 tw-w-5 tw-ml-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        >
                        <path
                            fillRule="evenodd"
                            d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                        />
                        </svg>
                    </a>
                    </div>
                </div>
                <div className="tw-w-full tw-md:w-1/2 tw-lg:w-7/12 tw-hidden tw-md:block" />
                </div>
            </div>
            </section>
            {/* end hero section */}

            <section id="aboutus" className="tw-overflow-hidden !tw-bg-[#fff] tw-py-5 sm:tw-pb-12 sm:tw-pt-20 lg:tw-pb-[90px] lg:tw-pt-[120px] dark:tw-bg-dark">
              <div className="tw-container tw-mx-auto tw-px-5 sm:tw-px-0">
                <div className="tw--mx-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between">
                  <div className="tw-w-full tw-px-4 lg:tw-w-4/12">
                    <div className="tw--mx-3 tw-flex tw-items-center sm:tw--mx-4">
                      <div className="tw-w-full tw-px-3 sm:tw-px-4 xl:tw-w-1/2">
                        <div className="tw-py-3 sm:tw-py-4">
                          <img src="https://i.ibb.co.com/20p8gYr2/image-1.jpg" alt="" className="tw-w-full tw-rounded-2xl" />
                        </div>
                        <div className="tw-py-3 sm:tw-py-4">
                          <img src="https://i.ibb.co.com/fGFRfTVR/image-2.jpg" alt="" className="tw-w-full tw-rounded-2xl" />
                        </div>
                      </div>
                      <div className="tw-w-full tw-px-3 sm:tw-px-4 xl:tw-w-1/2">
                        <div className="tw-relative tw-z-10 tw-my-4">
                          <img src="https://i.ibb.co.com/hRJvTJcc/image-3.jpg" alt="" className="tw-w-full tw-rounded-2xl" />
                          <span className="tw-absolute tw--bottom-7 tw--right-7 tw-z-[-1]">
                            <svg width="134" height="106" viewBox="0 0 134 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="1.66667" cy="104" r="1.66667" transform="rotate(-90 1.66667 104)" fill="#3056D3" />
                    <circle cx="16.3333" cy="104" r="1.66667" transform="rotate(-90 16.3333 104)" fill="#3056D3" />
                    <circle cx="31" cy="104" r="1.66667" transform="rotate(-90 31 104)" fill="#3056D3" />
                    <circle cx="45.6667" cy="104" r="1.66667" transform="rotate(-90 45.6667 104)" fill="#3056D3" />
                    <circle cx="60.3334" cy="104" r="1.66667" transform="rotate(-90 60.3334 104)" fill="#3056D3" />
                    <circle cx="88.6667" cy="104" r="1.66667" transform="rotate(-90 88.6667 104)" fill="#3056D3" />
                    <circle cx="117.667" cy="104" r="1.66667" transform="rotate(-90 117.667 104)" fill="#3056D3" />
                    <circle cx="74.6667" cy="104" r="1.66667" transform="rotate(-90 74.6667 104)" fill="#3056D3" />
                    <circle cx="103" cy="104" r="1.66667" transform="rotate(-90 103 104)" fill="#3056D3" />
                    <circle cx="132" cy="104" r="1.66667" transform="rotate(-90 132 104)" fill="#3056D3" />
                    <circle cx="1.66667" cy="89.3333" r="1.66667" transform="rotate(-90 1.66667 89.3333)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="89.3333" r="1.66667" transform="rotate(-90 16.3333 89.3333)"
                      fill="#3056D3" />
                    <circle cx="31" cy="89.3333" r="1.66667" transform="rotate(-90 31 89.3333)" fill="#3056D3" />
                    <circle cx="45.6667" cy="89.3333" r="1.66667" transform="rotate(-90 45.6667 89.3333)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="89.3338" r="1.66667" transform="rotate(-90 60.3333 89.3338)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="89.3338" r="1.66667" transform="rotate(-90 88.6667 89.3338)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="89.3338" r="1.66667" transform="rotate(-90 117.667 89.3338)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="89.3338" r="1.66667" transform="rotate(-90 74.6667 89.3338)"
                      fill="#3056D3" />
                    <circle cx="103" cy="89.3338" r="1.66667" transform="rotate(-90 103 89.3338)" fill="#3056D3" />
                    <circle cx="132" cy="89.3338" r="1.66667" transform="rotate(-90 132 89.3338)" fill="#3056D3" />
                    <circle cx="1.66667" cy="74.6673" r="1.66667" transform="rotate(-90 1.66667 74.6673)"
                      fill="#3056D3" />
                    <circle cx="1.66667" cy="31.0003" r="1.66667" transform="rotate(-90 1.66667 31.0003)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="74.6668" r="1.66667" transform="rotate(-90 16.3333 74.6668)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="31.0003" r="1.66667" transform="rotate(-90 16.3333 31.0003)"
                      fill="#3056D3" />
                    <circle cx="31" cy="74.6668" r="1.66667" transform="rotate(-90 31 74.6668)" fill="#3056D3" />
                    <circle cx="31" cy="31.0003" r="1.66667" transform="rotate(-90 31 31.0003)" fill="#3056D3" />
                    <circle cx="45.6667" cy="74.6668" r="1.66667" transform="rotate(-90 45.6667 74.6668)"
                      fill="#3056D3" />
                    <circle cx="45.6667" cy="31.0003" r="1.66667" transform="rotate(-90 45.6667 31.0003)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="74.6668" r="1.66667" transform="rotate(-90 60.3333 74.6668)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="30.9998" r="1.66667" transform="rotate(-90 60.3333 30.9998)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="74.6668" r="1.66667" transform="rotate(-90 88.6667 74.6668)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="30.9998" r="1.66667" transform="rotate(-90 88.6667 30.9998)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="74.6668" r="1.66667" transform="rotate(-90 117.667 74.6668)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="30.9998" r="1.66667" transform="rotate(-90 117.667 30.9998)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="74.6668" r="1.66667" transform="rotate(-90 74.6667 74.6668)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="30.9998" r="1.66667" transform="rotate(-90 74.6667 30.9998)"
                      fill="#3056D3" />
                    <circle cx="103" cy="74.6668" r="1.66667" transform="rotate(-90 103 74.6668)" fill="#3056D3" />
                    <circle cx="103" cy="30.9998" r="1.66667" transform="rotate(-90 103 30.9998)" fill="#3056D3" />
                    <circle cx="132" cy="74.6668" r="1.66667" transform="rotate(-90 132 74.6668)" fill="#3056D3" />
                    <circle cx="132" cy="30.9998" r="1.66667" transform="rotate(-90 132 30.9998)" fill="#3056D3" />
                    <circle cx="1.66667" cy="60.0003" r="1.66667" transform="rotate(-90 1.66667 60.0003)"
                      fill="#3056D3" />
                    <circle cx="1.66667" cy="16.3333" r="1.66667" transform="rotate(-90 1.66667 16.3333)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="60.0003" r="1.66667" transform="rotate(-90 16.3333 60.0003)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="16.3333" r="1.66667" transform="rotate(-90 16.3333 16.3333)"
                      fill="#3056D3" />
                    <circle cx="31" cy="60.0003" r="1.66667" transform="rotate(-90 31 60.0003)" fill="#3056D3" />
                    <circle cx="31" cy="16.3333" r="1.66667" transform="rotate(-90 31 16.3333)" fill="#3056D3" />
                    <circle cx="45.6667" cy="60.0003" r="1.66667" transform="rotate(-90 45.6667 60.0003)"
                      fill="#3056D3" />
                    <circle cx="45.6667" cy="16.3333" r="1.66667" transform="rotate(-90 45.6667 16.3333)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="60.0003" r="1.66667" transform="rotate(-90 60.3333 60.0003)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="16.3333" r="1.66667" transform="rotate(-90 60.3333 16.3333)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="60.0003" r="1.66667" transform="rotate(-90 88.6667 60.0003)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="16.3333" r="1.66667" transform="rotate(-90 88.6667 16.3333)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="60.0003" r="1.66667" transform="rotate(-90 117.667 60.0003)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="16.3333" r="1.66667" transform="rotate(-90 117.667 16.3333)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="60.0003" r="1.66667" transform="rotate(-90 74.6667 60.0003)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="16.3333" r="1.66667" transform="rotate(-90 74.6667 16.3333)"
                      fill="#3056D3" />
                    <circle cx="103" cy="60.0003" r="1.66667" transform="rotate(-90 103 60.0003)" fill="#3056D3" />
                    <circle cx="103" cy="16.3333" r="1.66667" transform="rotate(-90 103 16.3333)" fill="#3056D3" />
                    <circle cx="132" cy="60.0003" r="1.66667" transform="rotate(-90 132 60.0003)" fill="#3056D3" />
                    <circle cx="132" cy="16.3333" r="1.66667" transform="rotate(-90 132 16.3333)" fill="#3056D3" />
                    <circle cx="1.66667" cy="45.3333" r="1.66667" transform="rotate(-90 1.66667 45.3333)"
                      fill="#3056D3" />
                    <circle cx="1.66667" cy="1.66683" r="1.66667" transform="rotate(-90 1.66667 1.66683)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="45.3333" r="1.66667" transform="rotate(-90 16.3333 45.3333)"
                      fill="#3056D3" />
                    <circle cx="16.3333" cy="1.66683" r="1.66667" transform="rotate(-90 16.3333 1.66683)"
                      fill="#3056D3" />
                    <circle cx="31" cy="45.3333" r="1.66667" transform="rotate(-90 31 45.3333)" fill="#3056D3" />
                    <circle cx="31" cy="1.66683" r="1.66667" transform="rotate(-90 31 1.66683)" fill="#3056D3" />
                    <circle cx="45.6667" cy="45.3333" r="1.66667" transform="rotate(-90 45.6667 45.3333)"
                      fill="#3056D3" />
                    <circle cx="45.6667" cy="1.66683" r="1.66667" transform="rotate(-90 45.6667 1.66683)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="45.3338" r="1.66667" transform="rotate(-90 60.3333 45.3338)"
                      fill="#3056D3" />
                    <circle cx="60.3333" cy="1.66683" r="1.66667" transform="rotate(-90 60.3333 1.66683)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="45.3338" r="1.66667" transform="rotate(-90 88.6667 45.3338)"
                      fill="#3056D3" />
                    <circle cx="88.6667" cy="1.66683" r="1.66667" transform="rotate(-90 88.6667 1.66683)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="45.3338" r="1.66667" transform="rotate(-90 117.667 45.3338)"
                      fill="#3056D3" />
                    <circle cx="117.667" cy="1.66683" r="1.66667" transform="rotate(-90 117.667 1.66683)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="45.3338" r="1.66667" transform="rotate(-90 74.6667 45.3338)"
                      fill="#3056D3" />
                    <circle cx="74.6667" cy="1.66683" r="1.66667" transform="rotate(-90 74.6667 1.66683)"
                      fill="#3056D3" />
                    <circle cx="103" cy="45.3338" r="1.66667" transform="rotate(-90 103 45.3338)" fill="#3056D3" />
                    <circle cx="103" cy="1.66683" r="1.66667" transform="rotate(-90 103 1.66683)" fill="#3056D3" />
                    <circle cx="132" cy="45.3338" r="1.66667" transform="rotate(-90 132 45.3338)" fill="#3056D3" />
                    <circle cx="132" cy="1.66683" r="1.66667" transform="rotate(-90 132 1.66683)" fill="#3056D3" />
                  </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tw-w-full tw-px-4 lg:tw-w-8/12 xl:tw-w-7/12">
                    <div className="tw-mt-10 lg:tw-mt-0">
                      <span className="tw-mb-4 tw-block tw-text-3xl md:tw-text-5xl tw-font-bold tw-text-primary tw-title-gradient">
                        Kenapa Social Bread for Enterprise?
                      </span>
                      <h2 className="tw-mb-5 tw-text-base md:tw-text-lg tw-font-medium !tw-text-dark">
                        Kami menyediakan para ahli khusus, sumber daya, dan keunggulan strategis yang mungkin tidak tersedia secara internal. Berikut adalah beberapa alasan utama mengapa bisnis perlu menggunakan layanan kami:
                      </h2>
            
                      <div className="tw-blocks">
                        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-8">
                          <div className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-xl">
                            <div className="tw-w-14 tw-h-14 tw-rounded-full gradient-bg2 tw-text-[#fff] tw-flex tw-items-center tw-justify-center tw-mb-6">
                              <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                                </svg>
                            </div>
                            <h3 className="tw-text-xl tw-font-semibold tw-text-dark tw-mb-3">Pengalaman dan Keahlian</h3>
                            <p className="tw-text-gray-600 tw-text-sm">Kami mempekerjakan para profesional dengan beragam keterampilan dan pengalaman dalam berbagai aspek marketing, seperti digital marketing, media sosial, pembuatan konten, SEO, desain grafis, dan banyak lagi.</p>
                          </div>
                          <div className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-xl">
                            <div className="tw-w-14 tw-h-14 tw-rounded-full gradient-bg2 tw-flex tw-items-center tw-justify-center tw-mb-6">
                              <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                </svg>
                            </div>
                            <h3 className="tw-text-xl tw-font-semibold tw-text-dark tw-mb-3">Biaya Efektif</h3>
                            <p className="tw-text-gray-600 tw-text-sm">Kami bisa memberikan perspektif dari orang luar yang tidak memihak pada bisnis dan upaya pemasaran anda yang dapat mengarah pada ide dan strategi inovatif yang mungkin telah diabaikan secara internal.</p>
                          </div>
                          <div className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-xl">
                            <div className="tw-w-14 tw-h-14 tw-rounded-full gradient-bg2 tw-flex tw-items-center tw-justify-center tw-mb-6">
                              <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                            </div>
                            <h3 className="tw-text-xl tw-font-semibold tw-text-dark tw-mb-3">Objektif & Perspektif Baru</h3>
                            <p className="tw-text-gray-600 tw-text-sm">Kami bisa memberikan perspektif dari orang luar yang tidak memihak pada bisnis dan upaya pemasaran anda yang dapat mengarah pada ide dan strategi inovatif yang mungkin telah diabaikan secara internal.</p>
                          </div>
                          <div className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md tw-transition-all tw-duration-300 hover:tw-shadow-xl">
                            <div className="tw-w-14 tw-h-14 tw-rounded-full gradient-bg2 tw-flex tw-items-center tw-justify-center tw-mb-6">
                              <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-6 tw-w-6 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                                </svg>
                            </div>
                            <h3 className="tw-text-xl tw-font-semibold tw-text-dark tw-mb-3">Skalabilitas</h3>
                            <p className="tw-text-gray-600 tw-text-sm">Tim kami dapat beradaptasi dengan perubahan kebutuhan dan batasan anggaran bisnis anda, kami dapat menyesuaikan layanan kami sesuai kebutuhan.</p>
                          </div>
                        </div>
                      </div>
            
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* end section about */}

            {/* start service section */}
            <ServicesSection />            
            {/* end service section */}

            {/* start team section */}
            <TeamSection />            
            {/* end team section */}

            {/* start team section */}
            <TestimonialsSection />     
            {/* end team section */}

            <style>
                {`
                .gradient-bg {
                background: linear-gradient(90deg, #4F46E5 0%, #818CF8 100%);
                }

                .gradient-bg2 {
                background: linear-gradient(90deg, #1b9f88 0%, #004c42 100%);
                }

                .title-gradient {
                /* // color gradient like dark_green1 to dark_green2 */
                background: linear-gradient(90deg, #004c42 0%, #1b9f88 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                }
                `}
            </style>
        </>
    )
}

export default Enterprise

